import { Link, Typography } from "@mui/material";
import {
  EMBARGOED_US_URL,
  END_USER_LICENSE_AGREEMENT_URL,
  FIRST_HERE_URL,
  IMAGIO_EMAIL_URL,
  PRIVACY_STATEMENT_URL,
  SECOND_HERE_URL,
  SUBSIDIARIES_URL,
  US_EAR_URL,
} from "../commons/constants";

export const ExportControlContent = () => {
  const embargoedLink = () => {
    return (
      <Link target="_blank" href={EMBARGOED_US_URL}>
        embargoed by the U.S.
      </Link>
    );
  };

  const usEAR = () => {
    return (
      <Link target="_blank" href={US_EAR_URL}>
        U.S. Export Administration Regulations (“EAR”)
      </Link>
    );
  };

  return (
    <Typography
      sx={{
        fontSize: "var(--body-b2-14-regular-size, 14px)",
        textAlign: "justify",
      }}
    >
      As a national of a country not currently sanctioned or {embargoedLink()},
      you acknowledge you are permitted to access the Information that may
      include technical data or other materials that are regulated under the{" "}
      {usEAR()} or the applicable laws or regulations of other jurisdictions.
      You agree to fully comply with such export laws and regulations and will
      not export, re-export, or transfer Information, directly or indirectly,
      except as permitted by such laws and regulations.
    </Typography>
  );
};

const privacyStatement = () => {
  return (
    <Link target="_blank" href={PRIVACY_STATEMENT_URL}>
      privacy statement
    </Link>
  );
};

const subsidiaries = () => {
  return (
    <Link target="_blank" href={SUBSIDIARIES_URL}>
      subsidiaries
    </Link>
  );
};

export const PrivacyPolicy = () => {
  const emailTo = () => {
    return (
      <Link target="_blank" href={`mailto:${IMAGIO_EMAIL_URL}`}>
        imagio@covestro.com
      </Link>
    );
  };

  return (
    <Typography
      sx={{
        fontSize: "var(--body-b2-14-regular-size, 14px)",
        textAlign: "justify",
      }}
    >
      I agree that Covestro Deutschland AG and its {subsidiaries()} may process
      my personal data (name, user name, email, company, location, industry, job
      title, usage frequency, viewed data sets, downloaded data sets, search
      history) to analyze the usage of its service in order to measure and
      improve its services and products as described in further detail in the{" "}
      {privacyStatement()}. I understand that I can withdraw my consent at any
      time with effect for the future by sending a withdraw e-mail to{" "}
      {emailTo()}, leading to deletion of my account.
    </Typography>
  );
};

export const Eula = () => {
  const endUserLicenseAgreement = () => {
    return (
      <Link target="_blank" href={END_USER_LICENSE_AGREEMENT_URL}>
        End-User License Agreement
      </Link>
    );
  };

  const listItem = () => {
    return (
      <ul>
        <li key="KeyItemOne">
          Downloaded data shall only be used for my internal optical simulation
          purposes.
        </li>
        <li key="KeyItemTwo">
          Downloaded data shall not be shared with third parties (please use the
          option provided in the web-application to invite person for
          registration). This includes also processed formats like scene-files
          and its content.
        </li>
        <li key="KeyItemThree">
          The rights to use of the downloaded data are limited to 1 year after
          the download data maybe re-downloaded once a year to continue usage (a
          reminder will be send out to you in due time).
        </li>
      </ul>
    );
  };

  return (
    <Typography
      sx={{
        fontSize: "var(--body-b2-14-regular-size, 14px)",
        textAlign: "justify",
        "> ul": { margin: 0 },
      }}
    >
      I have read and accept the {endUserLicenseAgreement()}. Particularly, I
      understand that:
      {listItem()}
    </Typography>
  );
};

export const welcomeToImagio = () => {
  const firstHere = () => {
    return (
      <Link target="_blank" href={FIRST_HERE_URL}>
        here
      </Link>
    );
  };

  const secondtHere = () => {
    return (
      <Link target="_blank" href={SECOND_HERE_URL}>
        here
      </Link>
    );
  };

  return (
    <Typography
      sx={{
        fontSize: "var(--body-b2-14-regular-size, 14px)",
        color: "rgba(0,0,0,0.87)",
        textAlign: "justify",
      }}
    >
      I agree that Covestro Deutschland AG and its {subsidiaries()} can inform
      me via e-mail, telephone and via Social Media as LinkedIn, LinkedIn
      Matched Audience, Facebook, Twitter, Youtube, Instagram or WeChat of
      products of Covestro. An overview of products of Covestro can be found{" "}
      {firstHere()}. Further advertising information sent to me may encompass
      product related trainings, product related webinars and other product
      related events as well as information including white papers, brochures,
      surveys and general news of Covestro. I understand that I can withdraw my
      consent at any time with effect for the future by either revoking my
      consent following this link {secondtHere()} or by clicking on the
      “unsubscribe link” integrated in each communication which I receive in
      this context. Further information about the data processing can be found
      in the {privacyStatement()}.
    </Typography>
  );
};
